/**
 * EL CONTACTO EN EL CUESTIONARIO: CORREO, CELULAR Y TELEFONO DEL NEGOCIO
 * (ONB-TELEFONO-NEGOCIO-T1 lado panel; COORD de Argy-A #15583; FINDING de P #15604).
 *
 * DOS COSAS, UNA REGLA.
 *
 * 1. El telefono del NEGOCIO. Antes el cierre copiaba el celular del dueno como telefono
 *    del negocio (14 de 24 negocios, A #15477). Con el api 270 el cuestionario manda
 *    businessPhone y businessPhoneHasWhatsapp, opcionales. Para no hacer escribir dos
 *    veces (idea de Josse) primero se pregunta si es el mismo celular.
 *
 * 2. La validacion. El API rechaza con 400 un correo o un telefono mal escritos, pero el
 *    chat los aceptaba: el cliente veia "Listo" y la sesion quedaba pending (#15604). Aqui
 *    vive la MISMA regla del API para volver a preguntar antes, y la lectura del 400 del
 *    cierre para volver a preguntar despues.
 *
 * LA REGLA DEL API (NexoAPI OnboardingService, 9115d0c):
 *   telefono: quitar el + inicial, espacios, guiones y parentesis; 7 a 15 digitos.
 *   correo: ^[^@\s]+@[^@\s]+\.[^@\s]+$
 *   businessPhoneHasWhatsapp: true o false (nunca el texto "si").
 *   los 400 son ProblemDetails con un detail que empieza por la clave.
 *
 * Sin DOM: lo prueba scripts/check-contacto-onboarding.mjs.
 */

const tiene = (v) => v != null && String(v).trim() !== '';

/** El telefono con la regla del API. */
export function telefonoValido(texto) {
  if (typeof texto !== 'string') return false;
  const digitos = texto.trim().replace(/^\+/, '').replace(/[\s\-()]/g, '');
  return /^\d{7,15}$/.test(digitos);
}

/** El correo con la regla del API. */
export function correoValido(texto) {
  return typeof texto === 'string' && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(texto.trim());
}

export const MENSAJES_DE_CONTACTO = {
  ownerEmail: 'Ese correo no me cuadra 🤔 Escríbelo completo, con @ y el dominio (ej: nombre@gmail.com).',
  ownerPhone: 'Ese número no me cuadra 🤔 Escríbelo con todos sus dígitos (ej: 300 123 4567).',
  businessPhone: 'Ese teléfono no me cuadra 🤔 Escríbelo con todos sus dígitos, con indicativo si es fijo (ej: 604 444 1234).'
};

/** Lo que esta mal en una respuesta, en palabras, o null. Solo mira los campos de contacto. */
export function problemaDeLaRespuesta(field, valor) {
  if (field === 'ownerEmail') return correoValido(valor) ? null : MENSAJES_DE_CONTACTO.ownerEmail;
  if (field === 'ownerPhone' || field === 'businessPhone') return telefonoValido(valor) ? null : MENSAJES_DE_CONTACTO[field];
  return null;
}

/** Marca que solo vive en el navegador: no es del contrato y no viaja al API. */
export const CLAVES_LOCALES = ['mismoCelular'];

/**
 * Las tres preguntas nuevas, en orden, para ir despues del celular del dueno.
 * `sino`: se responde si o no con la regla del consentimiento. `cuando`: si aplica.
 */
export const PREGUNTAS_DEL_TELEFONO = [
  { field: 'mismoCelular', sino: true,
    q: '¿El teléfono del negocio es ese mismo celular, {ownerPhone}? (SÍ / NO)',
    cuando: (c) => !tiene(c.businessPhone) },
  { field: 'businessPhone',
    q: '¿Cuál es el teléfono del negocio? (fijo o celular)',
    cuando: (c) => c.mismoCelular === false },
  { field: 'businessPhoneHasWhatsapp', sino: true,
    q: '¿Ese número del negocio tiene WhatsApp? (SÍ / NO)',
    cuando: (c) => tiene(c.businessPhone) }
];

/** Si la pregunta aplica con lo capturado. */
export function aplica(pregunta, capturado) {
  return !pregunta || typeof pregunta.cuando !== 'function' || pregunta.cuando(capturado || {});
}

/** Que se guarda y que se envia al responder si o no. */
export function respuestaSiNo(field, si, capturado = {}) {
  if (field === 'mismoCelular') {
    return si
      ? { guardar: { mismoCelular: true, businessPhone: capturado.ownerPhone }, enviar: { businessPhone: capturado.ownerPhone } }
      : { guardar: { mismoCelular: false }, enviar: {} };
  }
  return { guardar: { [field]: si === true }, enviar: { [field]: si === true } };
}

/** El payload sin las marcas locales. No cambia el objeto recibido. */
export function sinClavesLocales(capturado) {
  const out = { ...(capturado || {}) };
  for (const k of CLAVES_LOCALES) delete out[k];
  return out;
}

const CLAVES_QUE_EL_API_NOMBRA = ['ownerEmail', 'ownerPhone', 'businessPhone', 'businessPhoneHasWhatsapp'];

/** La clave que nombra un 400 del API (ProblemDetails.detail), o null. */
export function claveDelRechazo(json) {
  const detalle = json && (json.detail ?? json.Detail ?? json.message ?? json.error);
  if (typeof detalle !== 'string') return null;
  const primera = detalle.trim().split(/\s+/)[0];
  return CLAVES_QUE_EL_API_NOMBRA.includes(primera) ? primera : null;
}

/** Que borrar para volver a preguntar lo que el API rechazo. */
export function clavesParaRepreguntar(clave) {
  if (clave === 'businessPhone') return ['businessPhone', 'mismoCelular', 'businessPhoneHasWhatsapp'];
  if (clave === 'ownerPhone') return ['ownerPhone', 'mismoCelular', 'businessPhone', 'businessPhoneHasWhatsapp'];
  return clave ? [clave] : [];
}
